// modules
import { createAction } from 'redux-actions'

export const setScheduledItems = createAction('SET_SCHEDULED_ITEMS')
export const setScheduledItemsLoading = createAction(
  'SET_SCHEDULED_ITEMS_LOADING'
)

export const setCreateCallLoading = createAction('SET_CREATE_CALL_LOADING')
export const setClinicianUsers = createAction('SET_CLINICIAN_USERS')
export const setActiveClinicianUsers = createAction(
  'SET_ACTIVE_CLINICIAN_USERS'
)

export const setWaitingRoomCount = createAction('SET_WAITING_ROOM_COUNT')
export const setPatientsListWithDevice = createAction(
  'SET_PATIENTS_LIST_WITH_DEVICE'
)

export const setModalVisibility = createAction('SET_MODAL_VISIBILITY')
export const setSchedulerModalVisibility = createAction(
  'SET_SCHEDULER_MODAL_VISIBILITY'
)
